import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
// import SignIn from '../pages/common/SignIn';
import Home from '../pages/community';
import Landing from '../pages/Landing';
import { getAmwayIdLoginUrl } from '../utils/login';
// import Registration from '../pages/common/Registration';
// import Login from '../pages/common/Login';

const AppRoutes = () => {
  function ExternalLoginRedirect() {
    useEffect(() => {
      window.location.href = getAmwayIdLoginUrl();
    }, []);
  
    return null;
  }
  
  return (
    <Routes>
      {/* <Route path="/sign-in" element={<SignIn />} /> */}
      <Route path="/" element={<Landing />}>
      <Route path="/:lang/login" element={<ExternalLoginRedirect />} />
        {/* <Route path="/:lang/login" element={<Login />} />
        <Route path="/:lang/registration" element={<Registration />} /> */}
        <Route path="/:lang/*" element={<Home />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
